module.exports = __webpack_public_path__ + "img/NGA.0d980142.svg";